import { type NavigateFunction } from "react-router-dom";
import { type AppDispatch } from "../../../store/store";
import { updateUserTokenDevice } from "../../../store/actionsCreators/userActions";
import { USER_ID_KEY } from "../../../urls";

export  const checkToken = async (dispatch: AppDispatch, navigate: NavigateFunction): Promise<void> => {
    const maxAttempts = 16;
    const     userID = window.localStorage.getItem(USER_ID_KEY)
    let attemptCount = 0;
    let currentToken: string | null = null;

    while (attemptCount < maxAttempts && !currentToken) {
        try {
            currentToken = (window as any).devicetoken || window.localStorage.getItem('devicetoken');
            if (currentToken) {
                await dispatch(updateUserTokenDevice(currentToken));
                //  initializeWebSocket(webSocket, dispatch, navigate, agentSocket);
                break;
            } else {
                attemptCount++;
                await new Promise(resolve => setTimeout(resolve, 500));
            }
        } catch (error) {
            console.error('Error updating token:', error);
            break;
        }
    }

    //  токен так и не найден
    if (!currentToken) {
        const fallbackToken = `BrowserTokenUnfound${userID}`;
        await dispatch(updateUserTokenDevice(fallbackToken));
        //  initializeWebSocket(webSocket, dispatch, navigate, agentSocket);
    }
};